// src/components/layouts/PanelLayout.jsx

import React from "react";
import { useLocation } from "react-router-dom";
import PortalSidebar from "../features/tomasConnect/portal/PortalSidebar";

function PanelLayout({ children }) {
  const location = useLocation();

  // 🔹 Detectar si estamos en rutas de empleado
  const path = location.pathname.toLowerCase();

  const esRutaEmpleado =
    path.includes("dashboardempleados") ||
    path.includes("misrecibos") ||
    path.includes("perfilempleado") ||
    path.includes("cambiar-password");

  return (
    <div className="tc-portal-shell">
      <PortalSidebar employee={esRutaEmpleado} />
      <main className="tc-portal-content">{children}</main>
    </div>
  );
}

export default PanelLayout;
